import './findme.css'
export const FindMe = () => {
    return(
        <h1 className="email">ryan@rthieu.com</h1>

    );
}